
enum HeaderEvents {
    ChangeMenu = "[HeaderEvent] ChangeMenu"
}

export default HeaderEvents;
